module.exports = __webpack_public_path__ + "img/gard_1.850b6ca8.png";